/* eslint-disable max-lines-per-function */
import {
  DataTableLoading,
  DatePickerSkeleton,
} from '../../components/Skeleton';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendarStar,
  faFilter,
  faSearch,
} from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { useManagerCanEditArbeitszeiten } from '../../hooks/useManagerCanEditArbeitszeit';
import { Input } from '@/components/ui/input';
import { faAnglesUpDown } from '@fortawesome/pro-regular-svg-icons';
import { Button } from '@/components/ui/button';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { buildLink } from '@/utils';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { NewDesignBanner } from '@/components/Banner/NewDesignBanner';

export default function UebersichtLoading() {
  const { year, month, day } = useParams();
  const { t } = useTranslation();
  const canEditArbeitszeit = useManagerCanEditArbeitszeiten();

  return (
    <>
      <NewDesignBanner link={buildLink('arbeitszeiten')} />
      <div className="bg-white pt-8">
        <div className="w-full flex justify-between items-start px-8 pb-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <DatePickerSkeleton year={year} month={month} day={day} />
            <div className="flex gap-1 items-center justify-center px-2 py-1.5 rounded-md bg-neutrals-N200 text-neutrals-N900 h-10">
              <FontAwesomeIcon icon={faCalendarStar} />
              <div className="text-sm">0</div>
            </div>
          </div>
          <div className="flex items-center gap-3 justify-end">
            {canEditArbeitszeit && (
              <Button
                variant="default"
                className="h-[42px] w-[42px]"
                size="icon"
                disabled>
                <FontAwesomeIcon icon={faPlus} className="font-bold" />
              </Button>
            )}
          </div>
        </div>
        <Tabs defaultValue="vollständig" className="flex flex-col">
          <div className="flex flex-row justify-between px-8 gap-3">
            <TabsList className="flex justify-start gap-4 w-fit overflow-x-scroll h-auto">
              <TabsTrigger
                defaultChecked
                className="flex items-center gap-2"
                key={'vollständig'}
                value="vollständig">
                {t('domain.arbeitszeiten.uebersicht.tabellenTabs.vollstaendig')}
              </TabsTrigger>
              <TabsTrigger
                className="flex items-center gap-2"
                key={'todo'}
                value="todo">
                {t('domain.arbeitszeiten.uebersicht.tabellenTabs.todo')}
              </TabsTrigger>
              {canEditArbeitszeit && (
                <TabsTrigger
                  className="flex items-center gap-2"
                  key={'dienstplanuebernahme'}
                  value="dienstplanuebernahme">
                  {t(
                    'domain.arbeitszeiten.uebersicht.tabellenTabs.dienstplanuebernahmen',
                  )}
                </TabsTrigger>
              )}
            </TabsList>
            <div className="flex gap-3 items-center lg:hidden">
              <Button variant="ghost" size="icon">
                <FontAwesomeIcon icon={faSearch} />
              </Button>
              <Button variant="ghost" size="icon">
                <FontAwesomeIcon icon={faFilter} />
              </Button>
            </div>
            <div className="hidden lg:flex lg:gap-3 lg:items-center">
              <Input
                startIcon={faSearch}
                placeholder={t(
                  'domain.arbeitszeiten.uebersicht.suche.placeholder',
                )}
                className="w-[280px]"
              />
              <div className="relative w-[280px] text-neutrals-N700">
                <Input
                  placeholder="Arbeitsbereich filtern"
                  className="w-full h-[42px] bg-white border border-neutrals-N300 ps-[22px] pr-10 font-normal placeholder:text-neutrals-N700 pt-[7px]"
                />
                <FontAwesomeIcon
                  icon={faAnglesUpDown}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-black text-sm pe-1"
                />
              </div>
            </div>
          </div>
        </Tabs>
        <div className="w-screen bg-neutrals-N200 mt-2">
          <DataTableLoading />
        </div>
      </div>
    </>
  );
}
